import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { siteInfo, navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-heart-fill text-background-50 text-lg"></i>
          </div>
          <span className={`font-heading font-bold text-xl ${scrolled ? "text-foreground-900" : "text-white"}`}>
            {siteInfo.logo}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.href
                  ? scrolled
                    ? "text-primary-600"
                    : "text-primary-300"
                  : scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-white/80 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="/about#contact"
            className={`text-sm font-medium px-5 py-2 rounded-full border transition-all duration-200 whitespace-nowrap cursor-pointer ${
              scrolled
                ? "border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-background-50"
                : "border-white/60 text-white hover:bg-white/20"
            }`}
          >
            联系我们
          </a>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            scrolled ? "text-foreground-900" : "text-white"
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium px-3 py-2 rounded-lg transition-colors ${
                  location.pathname === link.href
                    ? "bg-primary-50 text-primary-600"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="/about#contact"
              className="text-sm font-medium px-3 py-2 rounded-lg bg-primary-500 text-background-50 text-center cursor-pointer"
            >
              联系我们
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}